var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserRepository } from '../repositories/user-repository.interface';
import { UserInfoModel } from '../models/user-info-model.interface';
let UserInfoServiceImpl = class UserInfoServiceImpl {
    constructor(_userInfoModel, _userRepository) {
        this._userInfoModel = _userInfoModel;
        this._userRepository = _userRepository;
    }
    get userInfo() {
        return this._userInfoModel.userInfo;
    }
    updateUserInfo(userInfo) {
        this._userInfoModel.updateUserInfo(userInfo);
    }
    updateUserInfoIsCreatedSpace(isCreatedSpace) {
        this._userInfoModel.updateUserInfoIsCreatedSpace(isCreatedSpace);
    }
    updateUserInfoFromHeader(accountInfo) {
        this._userInfoModel.updateUserInfo(accountInfo);
    }
    updateUserInfoFreeView(isFreeView) {
        this._userInfoModel.updateUserInfoFreeView(isFreeView);
    }
    refreshUserInfoSpaceDataCount() {
        this._userRepository.getUserDataCount().then(res => {
            this._userInfoModel.updateUserInfoSpaceDataCount(res);
        });
    }
    subscribeUserInfo(callback) {
        return this._userInfoModel.subscribeUserInfo(callback);
    }
};
UserInfoServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserInfoModel)),
    __param(1, inject(UserRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserInfoModel !== "undefined" && UserInfoModel) === "function" ? _a : Object, typeof (_b = typeof UserRepository !== "undefined" && UserRepository) === "function" ? _b : Object])
], UserInfoServiceImpl);
export { UserInfoServiceImpl };
